import { Alert, AlertTitle, SvgIcon, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';
import I18n from '../../i18n/I18n';
import { Icons } from '../../icons/Icons';
import { ALERT_VARIANTS, AlertVariant } from '../../constants/constants';

type InfoAlertProps = {
    descriptionToken?: string;
    i18nValues?: { [key: string]: string | number | boolean };
    sx?: SxProps;
    action?: ReactNode;
    children?: ReactNode;
    title?: string;
    titleValues?: { [key: string]: string | number | boolean };
    icon?: boolean | ReactNode;
    titleSx?: SxProps;
    severity?: AlertVariant;
};

export default ({
    descriptionToken,
    i18nValues,
    sx,
    action,
    children,
    title,
    titleValues,
    titleSx,
    icon = <SvgIcon component={Icons.Info} />,
    severity = ALERT_VARIANTS.info
}: InfoAlertProps) => {
    return (
        <Alert
            severity={severity}
            sx={{
                width: '100%',
                alignItems: 'flex-start',
                p: 2,
                ...sx
            }}
            icon={icon}
            action={action}
        >
            {title ? (
                <AlertTitle sx={{ fontSize: 20, fontWeight: 'bold', lineHeight: 1, mt: 0, ...titleSx }}>
                    <I18n token={title} values={titleValues} />
                </AlertTitle>
            ) : (
                <></>
            )}
            {children || <I18n token={descriptionToken} values={i18nValues} />}
        </Alert>
    );
};
